/** @format */
import React from "react";
import { Box, Grid } from "@mui/material";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "react-router-dom";
import { logo } from "assets/images";

const Header = () => {
  return (
    <Box
      justifyContent={"center"}
      component={"nav"}
      height={"68px"}
      width={"100%"}
    >
      <Grid
        container
        sx={{
          height: "100%",
          paddingX: {
            xs: "15px",
            lg: "40px",
          },
        }}
        width={"100%"}
      >
        <Grid size={{ xs: 4 }}>
          <Box>
            <Link to={"/"}>
              <LazyLoadImage
                src={logo}
                alt="logo"
                effect="blur"
                height={"50px"}
              />
            </Link>
          </Box>
        </Grid>

        <Grid
          size={{ xs: 6 }}
          sx={{
            gap: {
              xs: "10px",
              md: "20px",
            },
          }}
          alignItems={"center"}
          justifyContent={"flex-end"}
        ></Grid>
      </Grid>
    </Box>
  );
};

export default Header;
